// web/src/components/Quest/QuestComponent.ts
import { QuestService } from "../services/QuestService";

export class QuestComponent extends HTMLElement {
    private questService: QuestService = new QuestService();
    private shadow: ShadowRoot;

    public constructor() {
        super();
        this.shadow = this.attachShadow({ mode: "open" });
    }

    public connectedCallback(): void {
        this.renderButton();
    }

    private renderButton(): void {
        this.shadow.innerHTML = `
            <style>
                #quest-btn {
                    padding: 8px 16px;
                    background: linear-gradient(135deg, #00eaff 0%, #0084ff 100%);
                    border: none;
                    border-radius: 4px;
                    font-family: 'Orbitron', sans-serif;
                    color: black;
                    font-weight: bold;
                    cursor: pointer;
                    box-shadow: 0 0 8px #00eaff;
                    transition: all 0.3s ease;
                }
                #quest-btn:hover {
                    transform: scale(1.05);
                    box-shadow: 0 0 12px #00eaff;
                }
            </style>
            <button id="quest-btn">📜 Quest Objectives</button>
        `;
        this.shadow.getElementById("quest-btn")?.addEventListener("click", () => this.showObjectives());
    }

    private async showObjectives(): Promise<void> {
        try {
            const { title, objectives } = await this.questService.getObjectives();
            this.renderObjectivesPopup(title, objectives);
        }
        catch (error) {
            console.error("Failed to load objectives:", error);
            this.showError("Couldn't load quest objectives");
        }
    }

    private renderObjectivesPopup(title: string, objectives: string[]): void {
        // eslint-disable-next-line @typescript-eslint/typedef
        const overlay = document.createElement("div");
        overlay.innerHTML = `
            <style>
                .quest-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    background: rgba(0, 0, 0, 0.9);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 9999;
                    backdrop-filter: blur(5px);
                }
                .quest-popup {
                    background: #0a0a1e;
                    border: 2px solid #00eaff;
                    border-radius: 8px;
                    padding: 24px;
                    max-width: 500px;
                    width: 90%;
                    box-shadow: 0 0 20px #00eaff;
                    animation: fadeIn 0.3s ease-out;
                }
                .quest-title {
                    color: #00eaff;
                    font-size: 1.5rem;
                    margin-bottom: 16px;
                    text-shadow: 0 0 8px #00eaff;
                }
                .quest-list {
                    list-style-type: none;
                    padding: 0;
                    margin: 0;
                }
                .quest-item {
                    padding: 8px 0;
                    color: #eaeaea;
                    border-bottom: 1px solid #333;
                }
                .close-btn {
                    margin-top: 16px;
                    padding: 8px 16px;
                    background: #ff5555;
                    border: none;
                    border-radius: 4px;
                    color: white;
                    cursor: pointer;
                }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(-20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
            </style>
            <div class="quest-overlay">
                <div class="quest-popup">
                    <h2 class="quest-title">${title}</h2>
                    <ul class="quest-list">
                        ${objectives.map(obj => `
                            <li class="quest-item">${obj}</li>
                        `).join("")}
                    </ul>
                    <button class="close-btn">Close</button>
                </div>
            </div>
        `;

        overlay.querySelector(".close-btn")?.addEventListener("click", () => {
            overlay.remove();
        });

        document.body.appendChild(overlay);
    }

    private showError(message: string): void {
        const errorToast: HTMLDivElement = document.createElement("div");
        errorToast.style.position = "fixed";
        errorToast.style.bottom = "20px";
        errorToast.style.left = "50%";
        errorToast.style.transform = "translateX(-50%)";
        errorToast.style.backgroundColor = "#ff5555";
        errorToast.style.color = "white";
        errorToast.style.padding = "8px 16px";
        errorToast.style.borderRadius = "4px";
        errorToast.style.zIndex = "10000";
        errorToast.textContent = message;

        document.body.appendChild(errorToast);
        setTimeout(() => errorToast.remove(), 3000);
    }
}
